import { type Keys, useHotkeys } from 'react-hotkeys-hook';

const HotKeyListener = ({
  onHotkeyPressed,
  hotkeys,
}: {
  onHotkeyPressed: () => void;
  hotkeys: Keys;
}) => {
  useHotkeys(hotkeys, (e) => {
    e.preventDefault();
    e.stopPropagation();
    onHotkeyPressed();
  });

  return null;
};

export default HotKeyListener;
